import { render } from "./ChildrenForms.vue?vue&type=template&id=10e26370"
import script from "./ChildrenForms.vue?vue&type=script&lang=js"
export * from "./ChildrenForms.vue?vue&type=script&lang=js"

import "./ChildrenForms.vue?vue&type=style&index=0&id=10e26370&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__